<template>
    <!-- Adım 2: Primleri yükle. Mevcut Banka 2 yükleme formu ve ucu kullanılır (GSalaryPayment Id / TMS-KOD ile eşleşir). -->
    <div>
        <b-modal id="dds-upload" title="Prim Excel’i Yükle" scrollable no-close-on-esc no-close-on-backdrop>
            <g-calculate-salary-process-upload v-model="uploadObject"></g-calculate-salary-process-upload>
            <template #modal-footer><v-executer :loading="uploading" :action="upload">Yükle</v-executer></template>
        </b-modal>

        <b-card class="mb-1">
            <div class="d-flex flex-wrap align-items-center g-1">
                <div class="mr-auto">
                    <h5 class="mb-25">Prim Excel’ini yükleyin</h5>
                    <div class="text-muted small">1. adımda indirdiğiniz Prim Yükleme Excel’ini doldurup yükleyin. Yemek Kart tutarı, yüklenen Yemek Ücreti’nden alınır.</div>
                    <div v-if="previewMode" class="small mt-50">
                        <template v-if="previewFile">Seçilen dosya: <strong>{{ previewFile.name }}</strong>. Primler 3. adımda Sicil Numarası ile eşlenip uygulanır; kayıt yazılmaz.</template>
                        <template v-else>Önizlemede dosya seçmeden de ilerleyebilirsiniz; bu durumda primler 0 kabul edilir.</template>
                    </div>
                </div>
                <button class="btn btn-primary" v-on:click="openUpload">
                    <feather-icon icon="UploadIcon" class="mr-50"></feather-icon>
                    Excel Yükle
                </button>
            </div>
            <template v-if="results">
                <hr>
                <div class="mb-50"><strong>{{ results.length }}</strong> satır okundu, <strong :class="errorRows.length ? 'text-danger' : 'text-success'">{{ errorRows.length }}</strong> satırda hata var.</div>
                <div v-if="errorRows.length" class="table-responsive">
                    <table class="table table-sm table-bordered mb-0">
                        <thead><tr><th>Excel satırı</th><th>Personel</th><th>Hata</th></tr></thead>
                        <tbody>
                            <tr v-for="(r,i) in errorRows" :key="i">
                                <td class="text-nowrap">{{ r.Row }}</td>
                                <td class="text-nowrap">{{ r.EmployeeFullName || r.EmployeeRegistrationCode }}</td>
                                <td class="text-danger">{{ (r.Errors || []).join(', ') }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </template>
        </b-card>
        <b-card no-body class="p-50">
            <div class="row justify-content-end">
                <div class="col-auto">
                    <button class="btn btn-sm btn-outline-secondary" v-on:click="$emit('back')">Geri</button>
                </div>
                <div class="col-auto">
                    <button class="btn btn-sm btn-secondary" v-on:click="$emit('next')">İleri</button>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
import { BCard, BModal } from 'bootstrap-vue'
import EmployeeOperationsApi from '@/api/employee-operations'
import Additional from '@/utilities/additional'
import GCalculateSalaryProcessUpload from '../../calculate-salary-process-g/components/GCalculateSalaryProcessUpload.vue'

export default {
    components: { BCard, BModal, GCalculateSalaryProcessUpload },
    props: {
        donem: { type: Object, default: () => ({ year: null, month: null }) },
        filter: { type: Object, default: () => ({}) },
        previewMode: { type: Boolean, default: false },
        previewFile: { type: [File, Object], default: null }
    },
    data() {
        return {
            uploadObject: { File: null, Month: null, Year: null },
            uploading: false,
            results: null
        }
    },
    computed: {
        errorRows() {
            return (this.results || []).filter(r => r.Errors && r.Errors.length)
        }
    },
    methods: {
        openUpload() {
            this.uploadObject.File = null
            this.uploadObject.Month = this.donem.month
            this.uploadObject.Year = this.donem.year
            this.$showModal('dds-upload')
        },
        async upload(override = false) {
            if (this.previewMode) {
                // Önizleme: dosya sunucuya şimdi gönderilmez; 3. adımda hesapla birlikte gider.
                if (!this.uploadObject.File) return
                this.$emit('preview-file', this.uploadObject.File)
                this.$hideModal('dds-upload')
                return
            }
            this.uploading = true
            const formData = await Additional.ToFormData({ ...this.uploadObject, Override: override }, ['File'])
            EmployeeOperationsApi.GSalary.UploadGTable(formData).then(res => {
                this.uploading = false
                if (!res.data.Success && res.data.Message == 'OVERRIDE_REQUIRED') {
                    this.$confirm('Yüklemek istediğinize emin misiniz?', 'Yüklediğiniz satırlar arasında onaylanmış kayıtlar var. Devam ederseniz onayları kaldırılır.').then(c => { if (c) this.upload(true) })
                    return
                }
                if (res.data.Success) {
                    this.results = res.data.Data || []
                    this.$hideModal('dds-upload')
                }
                this.$result(res)
            }).catch(err => {
                this.uploading = false
                this.$result(null, err)
            })
        }
    }
}
</script>
